import { type ProfileThemeKey, listProfileThemes, getProfileTheme } from './themes';

interface ProfileThemeSelectorProps {
  value: string | null | undefined;
  onChange: (theme: ProfileThemeKey) => void;
}

export default function ProfileThemeSelector({ value, onChange }: ProfileThemeSelectorProps) {
  const current = getProfileTheme(value || undefined);
  const themes = listProfileThemes();

  return (
    <div className="space-y-3">
      <p className="text-sm text-cocoa/70">Choose a palette for your public profile page.</p>
      <div className="grid gap-3 sm:grid-cols-2">
        {themes.map((theme) => {
          const selected = theme.key === current.key;
          return (
            <button
              key={theme.key}
              type="button"
              onClick={() => onChange(theme.key)}
              className={`group flex flex-col rounded-2xl border p-4 text-left transition ${
                selected ? 'border-cocoa shadow-md' : 'border-sand hover:border-cocoa/60'
              }`}
            >
              <div className={`flex h-16 items-center justify-center rounded-xl ${theme.backgroundClass}`}>
                <span className={`rounded-full px-3 py-1 text-xs font-semibold ${theme.accentClass}`}>
                  {theme.name}
                </span>
              </div>
              <p className={`mt-3 text-sm ${selected ? 'text-cocoa font-medium' : 'text-cocoa/70'}`}>
                {theme.description}
              </p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
